import React from "react";

export const PatternBackground = (props) => {
  return (
      <div className="background-container">
          <div className="container-fluid">
              <div className="row">
                  <div className="col-12">
                      {props.children}
                  </div>
              </div>
          </div>
      </div>
  )
}